// @flow
import {action, computed, observable} from 'mobx'
import {saveAs} from 'file-saver'
import {notification} from 'antd'
import {createTable, filterTable} from 'Utils'
import {Pagination} from './pagination'
import {Api} from 'Store/api'

export class Table {
  api: Api
  type: string
  name: string
  @observable data: {}[] = []
  @observable loading: boolean = false
  @observable pagination = new Pagination()
  @observable filter: string = ''
  @observable exportsLoading: {[key: string]: boolean} = {}

  constructor(api: Api, type: string, name: string) {
    this.api = api
    this.type = type
    this.name = name
  }

  @computed get table() {
    return filterTable(createTable(this.data), this.filter)
  }

  @action search(filter: string) {
    this.filter = filter
  }

  @action async load(id: number, page: number = 1) {
    this.loading = true
    this.pagination.set('page', page)
    try {
      const url = `sys/${this.type}s/${id}/tables/${this.name}?page=${page}`
      const {count, results} = await this.api.request(url, 'get')
      this.data = results
      this.pagination.set('count', count)
      if (Array.isArray(results) && page === 1) {
        this.pagination.set('size', results.length)
      }
    } catch (e) {
      notification['error']({
        message: `Failed to load ${this.name} table`,
        description: e.message || 'Unknown error'
      })
    } finally {
      this.loading = false
    }
  }

  @action async exportFile(id: number, format: string) {
    this.exportsLoading[format] = true
    const options = {
      headers: this.api.headers,
      method: 'GET'
    }
    try {
      const url = `api/v1/sys/${this.type}s/${id}/tables/${this.name}?export_as=${format}`
      const res = await fetch(url, options)
      const blob = await res.blob()
      saveAs(blob, `${this.name}.${format}`)
    } catch (e) {
      notification['error']({
        message: 'Failed to export file',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.exportsLoading[format] = false
    }
  }
}
